<template>
  <div>
    <main-header-info :navInfoItems="schema.navInfoItems" />
    <pat-login
      :schemaForm="schema.schemaForm"
      :modelForm="model"
      :save="handleLogin"
      :status="status"
    />
    <v-snack-bar :snackbar="snackbar" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import MainHeaderInfo from '@/components/includes/MainHeaderInfo.vue';
import PatLogin from '@/components/enter/PatLogin.vue';
import VSnackBar from '@/components/base/VSnackBar.vue';

export default {
  name: 'PatLoginPage',
  components: {
    MainHeaderInfo,
    PatLogin,
    VSnackBar,
  },
  data() {
    return {
      model: {
        email: '', 
        password: ''
      },
    };
  },
  mounted() {
    this.loadSchema();
  },
  computed: {
    ...mapGetters('patLoginPage', ['schema']),
    ...mapGetters('authPat', ['status', 'msgError']),
    ...mapGetters('notifications', ['snackbar']),
  },
  methods: {
    ...mapActions('patLoginPage', ['loadSchema']),
    ...mapActions('notifications', ['triggerSnackbar']),

    async handleLogin() {
      const model = this.model;

      this.$store.dispatch('authPat/login', model).then(
        () => {
          if (this.status === 'success') {
            this.$router.push({ name: 'pat-home' });
          } else if (this.status === 'error') {
            this.snackbar.visible = false;
            this.snackbar.visible = true;
            this.snackbar.content = this.msgError;

            this.$store.commit('auth/SET_STATUS', 'loaded');
          }
        },
        () => {
          this.snackbar.visible = false;
          this.snackbar.visible = true;
          this.snackbar.content = this.schema.snackError;

          this.$store.commit('auth/SET_STATUS', 'loaded');
        }
      );
    },
  },
};
</script>
